import {
	SET_THEMES,
	SET_THEME,
	CLEAR_THEMES,
	CLEAR_THEME,
	ADD_THEME,
	UPDATE_THEME,
	REMOVE_THEME,
} from './actionTypes';

export const theme = (state = {}, action) => {
	switch (action.type) {
		case SET_THEME:
			return action.payload;
		case UPDATE_THEME:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_THEME:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_THEMES:
			return action.payload;
		case ADD_THEME:
			return [...state, action.payload];
		case UPDATE_THEME:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_THEME:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_THEMES:
			return [];
		default:
			return state;
	}
};
